import { HealthAnalysisRecollectOrigin } from './../../module/health-analysis/journey/enum/health-analysis-recollect-origin.enum';
import { HealthAnalysisRecollectReason } from './../../module/health-analysis/journey/enum/health-analysis-recollect-reason.enum';

export const recollectReasons = [
    {
        value: HealthAnalysisRecollectReason.IDENTITY_MISSING,
        name: 'Falta de identificação da amostra',
        description: 'Origem: Paciente',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.USER
        }
    },
    {
        value: HealthAnalysisRecollectReason.EXCESS_OF_BIOLOGIC_MATERIAL,
        name: 'Excesso de material biológico',
        description: 'Origem: Paciente',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.USER
        }
    },
    {
        value: HealthAnalysisRecollectReason.EXTRAVASED_MATERIAL,
        description: 'Origem: Paciente',
        name: 'Material extravasado',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.USER
        }
    },
    {
        value: HealthAnalysisRecollectReason.INCORRECT_DATA,
        name: 'Cadastro preenchido incorretamente / Inconsistencias de cadastro',
        description: 'Origem: Paciente',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.USER
        }
    },
    {
        value: HealthAnalysisRecollectReason.EXPIRED_COLLECTOR_EXPIRATION_DATA,
        name: 'Prazo de validade do coletor vencido',
        description: 'Origem: Ciera',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.CIERA
        }
    },
    {
        value: HealthAnalysisRecollectReason.EXPIRED_COLLECTOR_EXPIRATION_DATA_PRESCRIBER,
        name: 'Prazo de validade',
        description: 'Origem: Prescritor',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.PRESCRIBER
        }
    },
    {
        value: HealthAnalysisRecollectReason.LOW_QUALITY_PROCESSING_DATA,
        name: 'Baixa qualidade no processamento da amostra',
        description: 'Origem: Ciera',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.CIERA
        }
    },
    {
        value: HealthAnalysisRecollectReason.OTHER_CAUSED_BY_USER,
        name: 'Outro motivo (descreva)',
        description: 'Origem: Paciente',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.USER
        }
    },
    {
        value: HealthAnalysisRecollectReason.OTHER_CAUSED_BY_CIERA,
        name: 'Outro motivo (descreva)',
        description: 'Origem: Ciera',
        metadata: {
            causedBy: HealthAnalysisRecollectOrigin.CIERA
        }
    }
];
